import {combineReducers} from 'redux-immutable';
import {mainReducer} from './mainreducer';
import {personReducer} from './personreducer';
import {contractReducer} from './contractreducer';

export const rootReducer = combineReducers({mainReducer, personReducer, contractReducer});
